import React, { useState } from 'react';
import * as css from './styles.module.css';

import FavoriteIcon from './favorite-icon';

const rarityBackgrounds = {
  common: css.common,
  rare: css.rare,
  elite: css.elite,
  super_rare: css.super_rare,
};

function getNameFontSize(name) {
  if (name.length > 15) {
    return 14;
  }

  return 18;
}

export default function DexCard({ iconUrl, name, rarity, number, hullType }) {
  const [ favorited, setFavorited ] = useState(false);

  function toggleFavorited() {
    setFavorited(favorited => !favorited);
  }

  return (
    <div className={css.card}>
      <div className={`${css.top} ${rarityBackgrounds[rarity]}`}>
        <img
          className={`${css.img} ${rarityBackgrounds[rarity]}`}
          src={iconUrl}
          alt=""
        />
        <div className={css.infoWrap}>
          <div className={css.class}>{hullType}</div>
          <div className={css.number}>{number}</div>
        </div>
      </div>

      <div className={css.nameWrap} style={{ fontSize: getNameFontSize(name) }}>
        {name}
      </div>

      <div className={css.favoriteWrap} onClick={toggleFavorited}>
        <FavoriteIcon active={favorited} />
      </div>

      <div className={css.toolbarWrap}>
        <div className={css.toolbarBtn}></div>
        <div className={css.toolbarBtn}></div>
        <div className={css.toolbarBtn}></div>
        <div className={css.toolbarBtn}></div>
        <div className={css.toolbarBtn}></div>
      </div>
    </div>
  );
}
